import { EventListenerTarget } from './types';
import { onPage } from './pageEventListener';
import { onComponent } from './componentEventListener';
import { onHotArea } from './hotAreaEventListener';

export function on(target, eventType, callback) {
  switch (target) {
    case EventListenerTarget.PAGE: {
      return onPage(eventType, callback);
    }
    case EventListenerTarget.COMPONENT: {
      return onComponent(eventType, callback);
    }
    case EventListenerTarget.HOT_AREA: {
      return onHotArea(eventType, callback);
    }
    default: {
      throw `Invalid [target], must one of '${EventListenerTarget.PAGE}', '${EventListenerTarget.COMPONENT}', '${EventListenerTarget.HOT_AREA}'`;
    }
  }
}
